import { type RefObject, useCallback, useEffect, useState } from 'react';

export const useHovered = (ref: RefObject<HTMLElement | null>) => {
  const [isHovered, setHovered] = useState(false);

  const onHoverIn = useCallback(() => {
    setHovered(true);
  }, []);

  const onHoverOut = useCallback(() => {
    setHovered(false);
  }, []);

  useEffect(() => {
    const node = ref.current;

    node?.addEventListener?.('mouseenter', onHoverIn);
    node?.addEventListener?.('mouseleave', onHoverOut);

    return () => {
      node?.removeEventListener?.('mouseenter', onHoverIn);
      node?.removeEventListener?.('mouseleave', onHoverOut);
    };
  }, [ref, onHoverIn, onHoverOut]);

  return isHovered;
};
